import { RootState } from '../store'
import { ChannelAbout } from './channelAbout.interface'

export const channelAboutSelector = (state: RootState): ChannelAbout =>
  // @ts-ignore
  state.channelAbout.data
